import React, { useContext } from 'react';

interface AppVersionContext {
    currentVersion: string;
}

const VersionContext = React.createContext<AppVersionContext>({
    currentVersion: `v. 2.83.6851dec2, 25.04.2025`,
});

export const useAppVersion = () => useContext(VersionContext);
